import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { GOAML_QUERY_KEYS } from 'app/modules/goAML/queries/keys';
import { GoAMLFilingDetails } from 'app/modules/goAML/models';
import { selectHasReadSARsPermissions } from 'app/modules/session/selectors';
import { get } from 'app/shared/utils/fetchr';

export const useGetGoamlFiling = (id: number) => {
  const hasReadSARsPermissions = useSelector(selectHasReadSARsPermissions);

  return useQuery({
    queryKey: GOAML_QUERY_KEYS.filing(id),
    queryFn: () => get<GoAMLFilingDetails>(`/v1/sars/${id}`),
    enabled: hasReadSARsPermissions && Boolean(id),
  });
};
